import { handleActions } from 'redux-actions';
import { businessReducerDefinition, initialBusinessState } from './business';
import { contentReducerDefinition, initialContentState } from './content';
import { initialTeamState, teamReducerDefinition } from './team';
import { initialUserState, userReducerDefinition } from './user';

export const initialState = {
  ...initialBusinessState,
  ...initialContentState,
  ...initialTeamState,
  ...initialUserState
};

const reducer = handleActions({
  ...businessReducerDefinition,
  ...contentReducerDefinition,
  ...teamReducerDefinition,
  ...userReducerDefinition
}, initialState);

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/business/reducers.js